import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import ProductList from './ProductList'

const Products = () => {
    const [productData, setProductData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [adding, setAdding] = useState(false)
    const [newProductName, setNewProductName] = useState(null)
    const [speciesValues, setSpeciesValues] = useState([])
    const [productSpeciesId, setProductSpeciesId] = useState(null)
    const [productWeight, setProductWeight] = useState(null)
    const [weightType, setWeightType] = useState(null)
    const [shortCode, setShortCode] = useState(null)
    const [getInventory, setGetInventory] = useState(null)

    useEffect (() => {
      getProducts()
    }, [])

    const getProducts = async () => {

        setErrorMsg('')
        setLoading(true)
        setProductData([])
        let session = await Auth.currentSession()
        let jwt = session.getIdToken().getJwtToken()

        axios
        .get(`${process.env.REACT_APP_API_URL}/product`,
        {headers: {Authorization: jwt}}
        )
        .then(response => {
            setProductData(response.data.rows)
            setSpeciesValues(response.data.speciesData)
            console.log('!!!!: ', response.data)
            console.log('SPECIES: ', speciesValues)
            setLoading(false)
        })
        .catch(error => {
            console.log('The error is: ', error)
            setErrorMsg('Problem retrieving data: ', error)
            setLoading(false)
        })            
    }

    const addNewClick = () => {
      setAdding(true)
      setProductSpeciesId(speciesValues[0].species_id)
      setWeightType('FIX')
      setGetInventory(1)
    }

    const onCancelClick = () => {
      setNewProductName(null)
      setProductSpeciesId(null)
      setProductWeight(null)
      setWeightType(null)
      setShortCode(null)
      setGetInventory(null)
      setAdding(false)
    }

    const saveProduct = async (e) => {
      e.preventDefault()

      setErrorMsg('')
      setSaving(true)
      let session = await Auth.currentSession()
      let jwt = session.getIdToken().getJwtToken()
      axios
          .put(`${process.env.REACT_APP_API_URL}/product`, {updateType: 'insert', productName: newProductName, productSpecies: productSpeciesId, productWeight, weightType, shortCode, getInventory},
          {headers: {Authorization: jwt}}
          )
          .then(response => {
            setSaving(false)
            if (response.data.error) {
              console.log(response.data.error)
              setErrorMsg('Problem saving data: ' + response.data.error)
            } else {
              setProductData(response.data.rows.map(newProductItem => {
                  return newProductItem
              }))
              setNewProductName(null)
              setProductSpeciesId(null)
              setProductWeight(null)
              setWeightType(null)
              setShortCode(null)
              setGetInventory(null)
              setAdding(false)
            }
          })
          .catch(error => {
              console.log('The error is: ', error)
              setErrorMsg('Problem saving data: ', error)
              setSaving(false)
          })            
    }

    return (
        <div className="report">
          <h2>Products</h2>
          { loading && <h3>Loading...</h3>}
          {errorMsg && <p className="form__error">{errorMsg}</p>}
          {!adding && <button className="button" onClick={addNewClick} disabled={loading || adding}>Add New</button>}
          {adding && <div>
            <h4>New Product:</h4>
            { saving && <h3>Saving...</h3>}
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Species</th>
                  <th>Product Name</th>
                  <th>Weight Type</th>
                  <th>Product Weight</th>
                  <th>Production Report Code</th>
                  <th>Managed Inventory</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <select className="msc__select text-input__margin" id="species" onChange={e => setProductSpeciesId(e.target.value)}>
                      {speciesValues && speciesValues.map((speciesRow) => (
                          <option key={speciesRow.species_id} value={speciesRow.species_id}>{speciesRow.species_name}</option>
                      ))}
                    </select>
                  </td>
                  <td>
                    <input 
                    type="text"
                    min="0"
                    className="text-input__customer-add-medium"
                    name="productName"
                    value={newProductName}
                    disabled={saving}
                    onChange={e => setNewProductName(e.target.value) } />
                  </td>
                  <td>
                    <select className="msc__select text-input__margin" id="weightType" onChange={e => setWeightType(e.target.value)}>
                      <option key='FIX' value='FIX'>Fixed</option>
                      <option key='VAR' value='VAR'>Variable</option>
                      <option key='BLK' value='BLK'>Bulk</option>
                    </select>
                  </td>
                  <td>
                    <input 
                      type="number"
                      min="0"
                      className="text-input__counter"
                      name="productWeight"
                      value={productWeight}
                      disabled={saving || weightType === 'VAR' || weightType === 'BLK'}
                      onChange={e => setProductWeight(e.target.value) } />
                  </td>
                  <td>
                    <input 
                      type="text"
                      className="text-input__customer-add-small"
                      name="shortCode"
                      value={shortCode}
                      disabled={saving}
                      onChange={e => setShortCode(e.target.value) } />                    
                  </td>
                  <td>
                    <select className="yes-no__select text-input__margin" id="getInventory" defaultValue={getInventory} onChange={e => setGetInventory(e.target.value)}>
                      <option key='1' value='1'>Yes</option>
                      <option key='0' value='0'>No</option>
                    </select>                    
                  </td>
                  <td>
                    <button className="table-button" onClick={onCancelClick} disabled={saving}>Cancel</button>
                  </td>
                  <td>
                    <button className="table-button" onClick={saveProduct} disabled={saving || !newProductName || !productSpeciesId || (weightType === 'FIX' && !productWeight)} >Add</button>
                  </td>
                </tr>
              </tbody>
            </table>              
          </div>}
          {productData.length > 0 && <div >
            <h4>Current Products:</h4>
            <table className="styled-table styled-table__fixed">
              <thead>
                  <tr>
                    <th>Species</th>
                    <th>Product Name</th>
                    <th>Weight Type</th>
                    <th>Product Weight</th>
                    <th>Production Report Code</th>
                    <th>Managed Inventory</th>
                    <th></th>
                    <th></th>
                  </tr>
              </thead>
              <tbody>
                {productData.map((productItem) => (
                  <ProductList
                    key={productItem.product_id}
                    productItem={productItem}
                    setProductData={setProductData}
                    setErrorMsg={setErrorMsg}
                  />
                ))}
              </tbody>
            </table>
          </div>}
        </div>
    )
}

export default Products